import { SC } from "../helper/ServerCall";

export const createOrderService = {
    getOrderSteps,
    getOrderFilterValues,
    getProducts,
    addProductsToCart,
    getCartProducts,
    getOrderProducts,
    deleteProductFromCart,
    placeOrder,
    getOrderAttributes,
    getOrdersList,
    saveCart,
    saveOrder,
    saveOrderStatus,
    getCustomerBrands,
    getCartsList,
    getCart,
    updateCartProduct,
    getOrderStates,
    getOrderStatesForBrand
};

function getCart(id) {
    return SC.getCall("orders/cart/" + id);
}

function placeOrder(data) {
    return SC.postCall("orders/place-order", data);
}

function getCustomerBrands(for_order = false) {
    return SC.getCall(`get-customer-brands?for_order=${for_order}`);
}

function saveOrder(data) {
    return SC.postCall("orders/save-order-details", data);
}

function saveOrderStatus(data) {
    return SC.postCall("orders/change-order-status", data);
}

function saveCart(data) {
    return SC.postCall("orders/save-cart", data);
}

function getOrderSteps(id) {
    return SC.getCall("brands/" + id + "/get-order-steps");
}

function getOrderAttributes(id) {
    return SC.getCall("orders/get-order-attributes/" + id);
}

function getCartsList(page, filter, pageSize) {
    return SC.getCall(
        "orders/get-open-carts" +
        "?page=" +
        page +
        "&filter=" +
        filter +
        "&pageSize=" +
        pageSize
    );
}

function getOrdersList(id, page, pageSize, sort, pagination, data) {
    return SC.postCall(
        "orders/get-orders/" +
        id +
        "?page=" +
        page +
        "&pageSize=" +
        pageSize +
        "&sort=" +
        sort +
        "&pagination=" +
        pagination, data
    );
}

function getOrderFilterValues(data) {
    return SC.postCall(
        "get-product-attribute-values",data
    );
}

function getProducts(data) {
    return SC.postCall("products/get-all?page=" + data.page, data);
}

function addProductsToCart(data) {
    return SC.postCall("products/add-to-cart", data);
}

function updateCartProduct(data) {
    return SC.postCall("products/update-cart-product", data);
}

function getCartProducts(data) {
    return SC.postCall("products/cart/get-all", data);
}

function getOrderProducts(data) {
    return SC.getCall("order/get-all-products/" + data.order_id + "?page=" + data.page + "&pageSize=" + data.pageSize);
}

function deleteProductFromCart(data) {
    return SC.postCall("products/cart/delete-product", data);
}

function getOrderStates() {
    return SC.getCall("order/get-sales-states");
}

function getOrderStatesForBrand(brand_id) {
    return SC.getCall(`order/get-sales-states?brand_id=${brand_id}`);
}



// WEBPACK FOOTER //
// ./src/services/createOrder.js